export enum Route {
  storage = 'storage',
  shipping = 'shipping',
  suitcase = 'suitcase',
}